import { render, staticRenderFns } from "./AllBuilding.vue?vue&type=template&id=78b4eedf&"
import script from "./AllBuilding.vue?vue&type=script&lang=js&"
export * from "./AllBuilding.vue?vue&type=script&lang=js&"
import style0 from "./AllBuilding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports